import { useEffect, useRef } from 'react';
import Socials from '../components/Socials';
import Tourbutton from '../components/Tourbutton';
import { gsap } from 'gsap';
import { Helmet } from 'react-helmet';

import victoryHand from '../assets/imgs/victory_hand.png';

const About = () => {
	const ref1 = useRef(null);
	const ref2 = useRef(null);
	const ref3 = useRef(null);

	useEffect(() => {
		const element1 = ref1.current;
		const element2 = ref2.current;
		const element3 = ref3.current;

		gsap.from(element1, 1, {
			delay: 1,
			ease: 'Elastic.easeOut',
			opacity: 0,
			x: -20,
		});

		gsap.from(element2, 1.5, {
			delay: 1.5,
			ease: 'power3.out',
			x: -20,
			opacity: 0,
		});

		gsap.from(element3, 1.5, {
			delay: 1.5,
			ease: 'Bounce.easeOut',
			y: 50,
			opacity: 0,
		});
	}, []);

	return (
		<section className="about-content">
			<Helmet>
				<title>Longinus Kings | About</title>
			</Helmet>
			<div className="left-section">
				<div className="left-section-content">
					<div className="container">
						<h2 ref={ref1}>
							About Me <span className="emoji">✌🏾</span>
						</h2>
						<p ref={ref2}>
							Yeah!😎 I'm a Senior Software Engineer with 8+ years of
							experience shipping products across fintech, e-commerce, and
							blockchain. Most recently I led engineering at Deltstack
							(2020–2025) — architecting dApps, DeFi solutions, and AI
							agent–driven workflows — and I'm the founder of Faciey, a
							face-recognition profile discovery app. I work across the
							stack: AI agents (LangGraph, LangChain), Web3 (Solidity,
							ethers.js, thirdweb), backend (Node.js, TypeScript, Python,
							RabbitMQ, PostgreSQL, Redis), frontend & mobile (React,
							Next.js, React Native), and DevOps (Docker, Kubernetes,
							CI/CD). I listen to music a lot (even when working 😅) — it
							helps ease the mind — and I play video games or soccer in my
							free time. My resume is available{' '}
							<a
								className="send-email-btn"
								href="https://drive.google.com/file/d/1RPHT-xfEoh4Kj4Iyhd9X7Ole-eUCaEI4/view?usp=sharing"
								target="_blank"
								rel="noreferrer"
							>
								Here
							</a>
						</p>
						<div className="social-links">
							<Socials />
							<Tourbutton path="/projects" text="continue" />
						</div>
					</div>
				</div>
			</div>
			<div className="right-section">
				<div className="hand-img" ref={ref3}>
					<img src={victoryHand} alt="hello" />
				</div>
			</div>
		</section>
	);
};

export default About;
